import { render } from "./ServiceListPage.vue?vue&type=template&id=2cc26620&ts=true"
import script from "./ServiceListPage.vue?vue&type=script&lang=ts"
export * from "./ServiceListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__